import { BasicEnumerable } from "../BasicEnumerable.js";
export const empty = () => {
    return new BasicEnumerable(function* () { });
};
